import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { getFilteredEvents } from '../services/HandleFiltering';

import EventEditor from './EventEditor.jsx';
import MapComponent from './map/MapComponent.jsx';
import Calendar from './Calendar.jsx';
import FilterView from './FilterView.jsx';

import './css/PageContainer.css';

const mapStateToProps = state => ({
  events: getFilteredEvents(state),
  view: state.view.view
});

const mapDispatchToProps = dispatch => ({});

class PageContainer extends Component {
  getPageView() {
    if (this.props.view === 'CALENDAR') {
      return <Calendar />;
    } else if (this.props.view === 'MAP') {
      return <MapComponent mapEvents={this.props.events} />;
    } else if (this.props.view === 'EDITOR') {
      return <EventEditor />;
    }

    return '';
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <div className="ibox">
              <FilterView />
              {this.getPageView()}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

PageContainer.propTypes = {
  events: PropTypes.array.isRequired,
  view: PropTypes.string.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(PageContainer);



// WEBPACK FOOTER //
// ./src/components/PageContent.jsx